import { css } from "@emotion/css";
import { Colors } from "@analyticsMD/quil";

export const styles = {
  scrollbar: css`
    &::-webkit-scrollbar {
      width: 0.5rem;
      background-color: white;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 7.5px;
      background-color: ${Colors.grey_15};
    }
  `,
};

export const sxStyles = {
  button: {
    textTransform: "capitalize",
    fontWeight: "bold",
  },
  buttonsWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "1rem",
    gap: "0.5rem",
    fontWeight: "bold",
  },
  listbox: {
    maxHeight: 170,
    padding: 10,
  },
  listItem: {
    paddingLeft: "0.5rem !important",
    paddingBottom: "0.5rem !important",
    fontSize: "0.9rem",
  },
  checkbox: {
    marginRight: "0.5rem",
    padding: "0.25rem",
  },
  inputLabel: {
    fontSize: "0.75rem",
    top: "3px",
  },
  outlinedInput: {
    fontSize: "0.9rem",
    width: "100%",
  },
  outlinedInputProp: {
    textAlign: "left",
    paddingLeft: "0.5rem",
    fontSize: "0.9rem",
  },
  tagText: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    marginRight: "0.25rem",
    display: "inline-block",
    flex: "0 1 auto",
    minWidth: 0,
    maxWidth: "100%",
  }
};
